import { Dialog } from "@luce/ui";

import { ChangePhoneNumberContext } from "./change-phone-number-context";
import { CancelChangePhoneNumberModal } from "./components/cancel-change-phone-number-modal";
import { ChangePhoneNumberForm } from "./components/change-phone-number-form";
import { ChangePhoneNumberOtpModal } from "./components/change-phone-number-otp-modal";
import { ChangePhoneNumberSuccessModal } from "./components/change-phone-number-success-modal";
import { DESCRIPTION, TITLE } from "./lib";
import type { ChangePhoneNumberModalProps, ChangePhoneNumberProps } from "./types";
import { useChangePhoneNumber } from "./use-change-phone-number";

function ChangePhoneNumberFlow({
  onClose,
  onPhoneNumberChanged,
}: ChangePhoneNumberProps & { onClose: () => void }) {
  const value = useChangePhoneNumber({ onExit: onClose, onPhoneNumberChanged });

  const handleOpenChange = (next: boolean) => {
    if (!next) onClose();
  };

  return (
    <ChangePhoneNumberContext.Provider value={value}>
      <Dialog.Root open={value.step === "form"} onOpenChange={handleOpenChange} size="sm">
        <Dialog.Header>
          <Dialog.Title>{TITLE}</Dialog.Title>
          <Dialog.Description>{DESCRIPTION}</Dialog.Description>
        </Dialog.Header>

        <Dialog.Body>
          <ChangePhoneNumberForm />
        </Dialog.Body>
      </Dialog.Root>

      <ChangePhoneNumberOtpModal />
      <CancelChangePhoneNumberModal />
      <ChangePhoneNumberSuccessModal />
    </ChangePhoneNumberContext.Provider>
  );
}

export function ChangePhoneNumberModal({
  open,
  onOpenChange,
  onPhoneNumberChanged,
}: ChangePhoneNumberModalProps) {
  if (!open) return null;

  return (
    <ChangePhoneNumberFlow
      onClose={() => onOpenChange(false)}
      onPhoneNumberChanged={onPhoneNumberChanged}
    />
  );
}
